import React, { Component } from "react";

// Components
import SvgIcon from "../../utils/SvgIcon";

// CSS
import "../../../css/document-icon.css";

class DocumentGroupRow extends Component {
	render() {
		const { file } = this.props;

		return (
			<a href={file.url} target="_blank" className="document-group--row">
				<div className="file-type">
					<SvgIcon type={file.type} />
				</div>
				<div className="filename">{file.title}</div>
			</a>
		);
	}
}

export default DocumentGroupRow;



// WEBPACK FOOTER //
// ./src/components/training/documents/DocumentGroupRow.js